import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

export const GET_CONSULTANT_STATEMENT_INTERESTS_HOLDS = gql`
  query ConsultantStatementInterestsHolds($consultantUuid: ID!) {
    consultantStatementInterestsHolds(consultantUuid: $consultantUuid) {
      uuid
      consultantUuid
      startDate
      endDate
      comment
      createdAt
      updatedAt
    }
  }
`;

export const useConsultantStatementInterestsHolds = (consultantUuid, skip = false) => {
  const { data, loading, error, refetch } = useQuery(GET_CONSULTANT_STATEMENT_INTERESTS_HOLDS, {
    variables: { consultantUuid },
    skip: skip || !consultantUuid,
    fetchPolicy: 'network-only',
  });

  return {
    data: data?.consultantStatementInterestsHolds || [],
    loading,
    error,
    refetch,
  };
};

export default useConsultantStatementInterestsHolds;
